import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Tabs from './components/Tabs';
import RegisterForm from './components/RegisterForm';
import InstantSearchForm from './components/InstantSearchForm';
import ViewSearches from './components/ViewSearches';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  const [activeTab, setActiveTab] = useState('register');
  const [editData, setEditData] = useState(null);

  const handleEditRecord = (record) => {
    setEditData(record);
    setActiveTab('register');
  };

  const handleClearEdit = () => {
    setEditData(null);
  };

  return (
    <AuthProvider>
      <div className="App">
        <ProtectedRoute>
          <div className="container">
            <Header />
            <main>
              <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
              
              {activeTab === 'register' && (
                <RegisterForm 
                  editData={editData} 
                  onClearEdit={handleClearEdit}
                />
              )}
              {activeTab === 'instant' && (
                <InstantSearchForm />
              )}
              {activeTab === 'view' && (
                <ViewSearches 
                  onEditRecord={handleEditRecord}
                />
              )}
            </main>
          </div>
        </ProtectedRoute>
      </div>
    </AuthProvider>
  );
}

export default App;
